import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/resume-bullet-generator/BulletGeneratorContent.tsx");
